import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IBannerCategory } from '../models/requestModels'

export class PostBannerCategoryOrder extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/banner/update-banner-category-order',
      requesterInfo,
    })
  }

  public async postBannerCategoryOrder(req: { CategoryIds: number[] }): Promise<IBannerCategory[]> {
    return await this.postAsync<IBannerCategory[]>(req)
  }
}
